import styled from 'styled-components';

const SubTitle = styled.h3<{ noMargin?: boolean }>`
  &&& {
    text-transform: uppercase;
    font-weight: bold;
    line-height: 22px;
    font-size: 13px;
    margin-bottom: ${({ noMargin }) => (noMargin ? 0 : '20px')};
  }
`;

export default SubTitle;
